import React from 'react';
import { UserProfile, ClubProfile } from '../../../utils/interfaces';
import CommonClubFields from './club_forms/CommonClubFields';
import DriverFields from './club_forms/DriverFields';
import FairwayWoodFields from './club_forms/FairwayWoodFields';
import UtilityFields from './club_forms/UtilityFields';
import IronsFields from './club_forms/IronsFields';
import WedgesFields from './club_forms/WedgesFields';
import PutterFields from './club_forms/PutterFields';

interface ClubsSectionProps {
  activeCategory: string;
  currentClubs: string[];
  editableProfile: UserProfile;
  handleProfileChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  handleRemoveClub: (clubName: string) => void;
}

const ClubsSection: React.FC<ClubsSectionProps> = ({
  activeCategory,
  currentClubs,
  editableProfile,
  handleProfileChange,
  handleRemoveClub,
}) => {
  // Ensure at least one club is present for Driver or Fairway or Utility or Irons or Wedges or Putter
  if (activeCategory === 'Driver' && currentClubs.length === 0) {
    currentClubs.push('Driver');
  }
  if (activeCategory === 'Fairway Woods' && currentClubs.length === 0) {
    currentClubs.push('3-Wood');
  }
  if (activeCategory === 'Utilities' && currentClubs.length === 0) {
    currentClubs.push('3-Hybrid');
  }
  if (activeCategory === 'Irons' && currentClubs.length === 0) {
    currentClubs.push('7-Iron');
  }
  if (activeCategory === 'Wedges' && currentClubs.length === 0) {
    currentClubs.push('Gap Wedge');
  }
  if (activeCategory === 'Putter' && currentClubs.length === 0) {
    currentClubs.push('Putter');
  }

  return (
    <>
      {activeCategory === 'Irons' && (
        <p className="irons-instruction" style={{ textAlign: 'center', margin: '0 0 1rem 0', fontStyle: 'italic' }}>
          You only need to input your model name once unless using a mixed set of irons.
        </p>
      )}
      <div className="profile-form-grid clubs-section">
        {currentClubs.map((clubName) => {
          const club = editableProfile[clubName as keyof UserProfile] as ClubProfile;
          const isOnlyClub = clubName === 'Driver' || clubName === 'Putter';
          return (
            <div key={clubName} className="club-card">
              {!isOnlyClub && (
                <div className="club-header">
                  <span className="club-name">{clubName}</span>
                  <button
                    type="button"
                    className="remove-club-btn"
                    onClick={() => handleRemoveClub(clubName)}
                    title="Remove this club"
                    hidden={isOnlyClub}
                  >
                    ×
                  </button>
                </div>
            )}
              <div className="club-fields">
                <CommonClubFields
                  clubName={clubName}
                  club={club}
                  activeCategory={activeCategory}
                  handleProfileChange={handleProfileChange}
                />
                {activeCategory === 'Driver' && (
                  <DriverFields
                    clubName={clubName}
                    club={club}
                    handleProfileChange={handleProfileChange}
                  />
                )}
                {activeCategory === 'Fairway Woods' && (
                  <FairwayWoodFields
                    clubName={clubName}
                    club={club}
                    handleProfileChange={handleProfileChange}
                  />
                )}
                {activeCategory === 'Utilities' && (
                  <UtilityFields
                    clubName={clubName}
                    club={club}
                    handleProfileChange={handleProfileChange}
                  />
                )}
                {activeCategory === 'Irons' && (
                  <IronsFields
                    clubName={clubName}
                    club={club}
                    handleProfileChange={handleProfileChange}
                  />
                )}
                {activeCategory === 'Wedges' && (
                  <WedgesFields
                    clubName={clubName}
                    club={club}
                    handleProfileChange={handleProfileChange}
                  />
                )}
                {activeCategory === 'Putter' && (
                  <PutterFields
                    clubName={clubName}
                    club={club}
                    handleProfileChange={handleProfileChange}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ClubsSection;
